module.exports = __webpack_public_path__ + "img/Lock Icon.f4768d40.svg";